export default __webpack_public_path__ + "static/media/chat_banner.52e30e8b.svg";